import axios from "axios";

const URL = "/os/api/notifications/";
const CHANGED = "ordo:notifications";

/** What the inbox entry says, in words. */
export const notificationText = ({kind, order_number: number, client_name: client}) => {
    if (kind === "confirmed") return `${client} confirmou a ordem nº ${number}`;
    if (kind === "canceled") return `${client} cancelou a ordem nº ${number}`;
    if (kind === "expired") return `A ordem nº ${number} expirou sem resposta de ${client}`;
    return `Novidade na ordem nº ${number}`;
};

/** Tell the bell that what it shows may be out of date (see NotificationBell). */
export const notificationsChanged = () => window.dispatchEvent(new Event(CHANGED));

/** Subscribes to `notificationsChanged`; returns the way to stop. */
export const onNotificationsChanged = (callback) => {
    window.addEventListener(CHANGED, callback);
    return () => window.removeEventListener(CHANGED, callback);
};

/** Opening an order is seeing what happened to it: mark its news as read. */
export const markOrderNewsRead = async (orderId) => {
    try {
        const {data} = await axios.post(`${URL}read_all/`, null, {params: {order: orderId}});
        if (data?.marked) notificationsChanged();
    } catch {
        // Not worth bothering anyone about: the bell shows it as unread a little longer.
    }
};
